/*
 * ap-saison.js — Anmeldung zur Saison-Erinnerung (Winter-/Sommerreifen).
 *
 * Gleicher Vertrag wie der Lieferalarm (ap-stock-alarm.js), nur mit dem
 * Saison-Proxy: GET fragt die Freischaltung ab ({ok, winter, sommer}),
 * erst dann erscheint das Formular; POST { email, season }. Antworttexte
 * kommen vom Server (deutsch, inkl. Double-Opt-in-Hinweis).
 */

(function () {
  'use strict';

  function init(root) {
    var proxy = root.getAttribute('data-proxy');
    var season = root.getAttribute('data-season');
    if (!proxy || !season) return;

    fetch(proxy, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cap) {
        if (!cap || cap[season] !== true) return;
        root.hidden = false;
        wire(root, proxy, season);
      })
      .catch(function () {
        /* Ohne Auskunft bleibt der Abschnitt weg. */
      });
  }

  function wire(root, proxy, season) {
    var form = root.querySelector('form');
    var mail = root.querySelector('input[type="email"]');
    var btn = root.querySelector('button');
    var out = root.querySelector('[data-ap-saison-status]');
    if (!form || !mail || !btn || !out) return;

    function say(message, ok) {
      out.textContent = message;
      out.classList.toggle('ap-stock-alarm__status--ok', !!ok);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!mail.value) {
        mail.focus();
        return;
      }
      btn.disabled = true;
      say('Wird gespeichert …', true);
      fetch(proxy, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email: mail.value, season: season }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          say((res && res.message) || 'Gespeichert.', !!(res && res.ok));
          if (res && res.ok) mail.value = '';
        })
        .catch(function () {
          say('Das hat gerade nicht geklappt. Bitte später erneut versuchen.', false);
        })
        .finally(function () {
          btn.disabled = false;
        });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ap-saison]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
